import React, { FC } from "react";
import styles from "./TermsCard.module.scss";
import Link from "next/link";
import AppCheckbox from "@/components/forms/checkboxes/AppCheckbox/AppCheckbox";
import { useTranslations } from "next-intl";

interface TermsCardProps {
  isChecked: boolean;
  handleCheckboxChange: () => void;
}

const TermsCard: FC<TermsCardProps> = ({
  isChecked,
  handleCheckboxChange,
}) => {
  const  t  = useTranslations();
  return (
    <div data-testid="TermsCard" className="  ">
      <div className="flex gap-2 items-center">
        <label
          htmlFor="termsCheckbox"
          className="cursor-pointer flex items-center gap-2"
        >
          <AppCheckbox
            label={<p className="text-sm font-semibold">{t("termsCard.confirmText")}</p>}
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
        </label>
      </div>

      <p className="text-xs leading-6  font-normal">
      {t("termsCard.acknowledgeText")}{" "}
        <Link href="/terms-and-conditions" className={styles.termsConditions}>
        {t("termsCard.termsLink")}

        </Link>{" "} {t("termsCard.and")} <Link href="/supplier-terms-and-conditions" className={styles.termsConditions}>
        {t("termsCard.supplierTermsLink")}
        </Link>{" "} 
      </p>
    </div>
  );
};

export default TermsCard;
